export const styles = () => ({
  containerReceived: {
    width: '100%',
    margin: '4px 0px',
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  containerSend: {
    width: '100%',
    margin: '4px 0px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  timeZone: {
    fontSize: 10,
    color: 'var(--color-spun-pearl-grey)',
    fontWeight: 300,
    whiteSpace: 'nowrap'
  },
  statusWrap: {
    padding: '0px 8px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
  },
  iconWithTooltip: {
    position: 'relative',
    display: 'inline-block',
    cursor: 'pointer',
  },
  tooltip: {
    visibility: 'hidden',
    backgroundColor: 'black',
    color: 'white',
    textAlign: 'center',
    padding: '5px',
    borderRadius: '8px',
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    fontSize: '14px',
    whiteSpace: 'nowrap',
    zIndex: 1000,
    opacity: 0,
    transition: 'opacity 0.3s',
  },
  iconWithTooltipHover: {
    '&:hover $tooltip': {
      visibility: 'visible',
      opacity: 0.8,
    },
  },
  feedbackContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: 8,
    gap: 12,
  },
  feedbackContent: {
    display: 'flex',
    alignItems: 'center',
    height: 25,
    padding: '4px 8px',
    border: '1px solid #577285',
    borderRadius: 4,
    backgroundColor: 'transparent',
    gap: 8,
    width: 'fit-content'
  },
  feedbackLabel: {
    color: '#7a7a7a',
    marginRight: 5,
    fontFamily: 'Lato',
    fontWeight: 400,
    fontStyle: 'Regular',
    fontSize: 14,
    leadingTrim: 'NONE',
    lineHeight: '100%',
    letterSpacing: 0.06,
  },
  feedbackIcon: {

  },
  feedbackStatus: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontStyle: 'Regular',
    fontSize: 14,
    leadingTrim: 'NONE',
    lineHeight: '100%',
    letterSpacing: 0.06,
    marginLeft: 10,
    color: '#577285',
  },
})
